import PropTypes from 'prop-types';
import React from 'react';
import PointActivityRow from './PointActivityRow';
import styles from './style.css';

class PointActivity extends React.Component {
  static maximumPointActivityToShow = 5;

  render() {
    const { customerDetail } = this.props;
    return (
      <div className="customer-info-box">
        <div className="header2">Point Activity</div>
        {customerDetail &&
        customerDetail.point_activities &&
        customerDetail.point_activities.content &&
        customerDetail.point_activities.content.length ? (
          <table
            style={{ marginBottom: '0px' }}
            className="table mk-table-fixed mk-table-clickable moka-table-details"
          >
            <thead>
              <tr>
                <th className="col-md-3">Date</th>
                <th className="col-md-5">Outlet</th>
                <th className="col-md-2 text-right">Sale</th>
                <th className="col-md-2 text-right">Point</th>
              </tr>
            </thead>
            <tbody>
              {this._getPointActivityRowsView(customerDetail.point_activities)}
              {customerDetail.point_activities.total_elements >
                PointActivity.maximumPointActivityToShow && (
                <tr>
                  <td
                    onClick={this._onClickSeeMore}
                    className={`${styles['see-more']} col-md-2`}
                  >
                    + See More
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          <div className={`${styles['no-point-activity']}`}>
            {' '}
            <i>No point activity</i>{' '}
          </div>
        )}
      </div>
    );
  }

  _onClickSeeMore = () => {
    this.props.seeMore(this.props.customerDetail.id);
  };

  _getPointActivityRowsView = pointActivities => {
    const pointActivityList = [];
    for (
      let i = 0;
      i < pointActivities.content.length &&
      i < PointActivity.maximumPointActivityToShow;
      i++
    ) {
      const pointActivity = pointActivities.content[i];
      pointActivityList.push(
        <PointActivityRow
          key={pointActivity.rowId}
          pointActivity={pointActivity}
          onClickRow={this._onClickRow}
        />
      );
    }

    return pointActivityList;
  };

  _onClickRow = data => {
    this.props.onClickHistory(data);
  };
}

PointActivity.propTypes = {
  customerDetail: PropTypes.object,
  onClickHistory: PropTypes.func,
};

export default PointActivity;
